import styled from "styled-components";

export const StyledHelp = styled.div`
  position: absolute;
  left: 75px;
  display: flex;
  align-items: center;
  height: 100%;
`;
export const HelpContainer = styled.div`
  font-size: 1rem;
  padding: 30px;
`;
export const HelpRow = styled.div`
  padding: 10px 15px;
  margin: 10px;
  background-color: ${(props) => props.theme.containerBackgroundTranslucent};
  border-radius: 15px;
  text-align: center;
`;
